import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import EventPage from './pages/EventPage.jsx';
import Toaster from './components/Toaster.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';

// EventPage reste eager : c'est l'entrée de l'invité (scan QR), on veut le chemin le
// plus court. Tout le reste (espaces pro, admin, Stripe, qr-scanner) est chargé à la
// demande pour ne pas peser sur le premier rendu mobile de l'invité sur réseau de bar.
const HomePage = lazy(() => import('./pages/HomePage.jsx'));
const ProLandingPage = lazy(() => import('./pages/ProLandingPage.jsx'));
const ProAuthPage = lazy(() => import('./pages/ProAuthPage.jsx'));
const DjLoginPage = lazy(() => import('./pages/DjLoginPage.jsx'));
const DjSignupPage = lazy(() => import('./pages/DjSignupPage.jsx'));
const DjAppPage = lazy(() => import('./pages/DjAppPage.jsx'));
const ManagerLoginPage = lazy(() => import('./pages/ManagerLoginPage.jsx'));
const ManagerSignupPage = lazy(() => import('./pages/ManagerSignupPage.jsx'));
const ManagerAppPage = lazy(() => import('./pages/ManagerAppPage.jsx'));
const AdminAppPage = lazy(() => import('./pages/AdminAppPage.jsx'));
const SpotifyOAuthCallbackPage = lazy(() => import('./pages/SpotifyOAuthCallbackPage.jsx'));

function RouteFallback() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg text-sm text-white/55">
      Chargement…
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/e/:qrCode" element={<EventPage />} />
          <Route path="/pro" element={<ProLandingPage />} />
          <Route path="/dj/auth" element={<ProAuthPage persona="dj" />} />
          <Route path="/manager/auth" element={<ProAuthPage persona="manager" />} />
          <Route path="/dj/login" element={<DjLoginPage />} />
          <Route path="/dj/signup" element={<DjSignupPage />} />
          <Route path="/dj/app" element={<DjAppPage />} />
          <Route path="/dj/app/:section" element={<DjAppPage />} />
          <Route path="/manager/login" element={<ManagerLoginPage />} />
          <Route path="/manager/signup" element={<ManagerSignupPage />} />
          <Route path="/manager/app" element={<ManagerAppPage />} />
          <Route path="/manager/app/:section" element={<ManagerAppPage />} />
          <Route path="/admin" element={<AdminAppPage />} />
          <Route path="/spotify-callback" element={<SpotifyOAuthCallbackPage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      <Toaster />
    </ErrorBoundary>
  );
}
